import OfferEvent from '@core/models/offer/OfferEvent';
import {
    createSelfCleaningClientStorage,
    SelfCleaningClientStorage,
} from '@core/utils/selfCleaningClientStorage/createSelfCleaningClientStorage';

export function updateCacheEventBettorNumber(events: OfferEvent[]): SelfCleaningClientStorage<number, number> {
    const cache = createSelfCleaningClientStorage<number, number>('bettorNumberCache');
    const entries = events.filter(
        (event) => event.id && event.id.toString().length > 0 && event.id > 0,
    ).reduce((acc, event) => {
        acc[event.id] = generateRandomNumber();
        return acc;
    }, {} as Record<number, number>);
    if (!Object.keys(entries).length) {
        return cache;
    }
    cache.setMany(entries);
    return cache;
}

function generateRandomNumber(): number {
    const quotientConstant = 100;
    const maxRange = 6_000;
    const fullNumber = Math.floor(Math.random() * (maxRange - quotientConstant));
    const minValue = 1_000;
    return (fullNumber - (fullNumber % quotientConstant)) + minValue;
}
